import { render, staticRenderFns } from "./ReturnCN.vue?vue&type=template&id=2bd0048e&scoped=true&"
import script from "./ReturnCN.vue?vue&type=script&lang=js&"
export * from "./ReturnCN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd0048e",
  null
  
)

export default component.exports